import React from 'react'
import TextField from '@mui/material/TextField'
import { NumericFormat } from 'react-number-format'
import { FilledInputProps, InputProps, OutlinedInputProps } from '@mui/material'

interface PriceInputProps {
  label: string
  value: number | undefined
  currency?: string
  error?: boolean
  InputProps?:
    | Partial<OutlinedInputProps>
    | Partial<InputProps>
    | Partial<FilledInputProps>
    | undefined
  onChange: (value: number) => void
}

function PriceInput({
  label,
  value,
  currency,
  error,
  InputProps,
  onChange,
}: PriceInputProps) {
  const isUsd = currency === 'usd'
  return (
    <NumericFormat
      value={value === 0 ? '' : value ?? ''}
      thousandSeparator={isUsd ? ',' : '.'}
      decimalSeparator={isUsd ? '.' : ','}
      decimalScale={2}
      fixedDecimalScale
      prefix={isUsd ? '$ ' : 'R$ '}
      customInput={TextField}
      fullWidth
      InputProps={InputProps}
      onValueChange={(values) => {
        onChange(parseFloat(values.value || '0'))
      }}
      size="small"
      label={label}
      error={error}
    />
  )
}

export default PriceInput
